import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import moment from "jalali-moment";
import { useAppContext } from "../../context/state";
import { storage, useRequest } from "../../utils";
var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";
import Select from "react-select";

import utils from "../../components/toastify/toastify";
import DatePicker from "react-modern-calendar-datepicker";

const addForumCategory = (props) => {
  // const [
  //   get_user_details_error,
  //   get_user_details_loading,
  //   get_user_details_data,
  //   get_user_details_function,
  // ] = useRequest({
  //   method: "post",
  //   url: "/get_user_details",
  //   body: {
  //     user_id: props.match.params.id,
  //   },
  // });

  // const [
  //   get_products_error,
  //   get_products_loading,
  //   get_products_data,
  //   get_products_function,
  // ] = useRequest({
  //   method: "get",
  //   url: "/get_products",
  // });

  // let [options, set_options] = useState();

  // const [selectedDay, setSelectedDay] = useState(null);
  // const [instagram, set_instagram] = useState("");
  // const [products, set_products] = useState(null);
  // const [code, set_code] = useState(null);
  // const [apply_to_all_products, set_apply_to_all_products] = useState(false);
  // const [discount_percent, set_discount_percent] = useState(0);

  // const [final_product, set_final_product] = useState({
  //   creation_date: null,
  //   product_id: null,
  //   payment: true,
  //   support_all_payment: true,
  //   term_ids: [],
  // });

  // useEffect(() => {
  //   const defaultValue = {
  //     year: Number(moment(Date.now()).locale("fa").format("YYYY")),
  //     month: Number(moment(Date.now()).locale("fa").format("M")),
  //     day: Number(moment(Date.now()).locale("fa").format("D")),
  //   };
  //   setSelectedDay(defaultValue);
  //   set_final_product((i) => ({
  //     ...i,
  //     creation_date: moment(
  //       String(
  //         `${defaultValue.year}/${
  //           String(defaultValue.month).length === 1
  //             ? "0" + defaultValue.month
  //             : defaultValue.month
  //         }/${
  //           String(defaultValue.day).length === 1
  //             ? "0" + defaultValue.day
  //             : defaultValue.day
  //         }`
  //       ),
  //       "jYYYY/jMM/jDD HH:mm"
  //     ).toISOString(),
  //   }));
  // }, []);

  // console.log(final_product);

  //   {
  //     term_id: null,
  //     payment: null,
  //     support_payment: null,
  //   },
  // const [product_data, set_product_Data] = useState(null);

  // useEffect(() => {
  //   if (final_product.product_id) {
  //     set_product_Data(options.find((i) => i._id === final_product.product_id));
  //   } else {
  //     set_product_Data(null);
  //   }
  // }, [final_product]);

  let history = useHistory();

  //   const [creation_date, set_creation_date] = useState(null);

  let [title, set_title] = useState("");
  // let [expiration_date, set_expiration_date] = useState();

  // useEffect(() => {
  //   if (get_products_data) {
  //     set_options(
  //       get_products_data.products
  //         .filter((i) => i.type !== "results" && i.type !== "videos")
  //         .map((i) => ({
  //           value: i._id,
  //           label: i.title,
  //         }))
  //     );
  //   }
  // }, [get_products_data]);

  // const customStyles = {
  //   control: (style) => ({
  //     // none of react-select's styles are passed to <Control />
  //     ...style,
  //     width: 300,
  //   }),
  // };

  const [
    add_forum_category_error,
    add_forum_category_loading,
    add_forum_category_data,
    add_forum_category_function,
  ] = useRequest({
    method: "post",
    isFunction: true,
    url: "/add_forum_category",
    body: {
      title,
    },
  });

  return (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">افزودن دسته بندی جدید</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">افزودن دسته بندی جدید</h4>
              </div>

              <div class="card">
                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                <div class="card-content">
                  <div class="card-body">
                    <form action="#" class="contact-repeater">
                      <div data-repeater-list="contact">
                        <div
                          class="row justify-content-between"
                          data-repeater-item
                        >
                          <div class="col-md-6 col-12 form-group d-flex align-items-center">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              دسته بندی :
                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                  marginTop: "10px",
                                }}
                                class="form-control"
                                placeholder="عنوان دسته بندی"
                                value={title}
                                onChange={(e) => set_title(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <button
                onClick={() => {
                  if (title) {
                    var $white = "#fff";
                    $.blockUI({
                      message:
                        '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

                      // timeout: 2000, //unblock after 2 seconds
                      overlayCSS: {
                        backgroundColor: $white,
                        opacity: 0.8,
                        cursor: "wait",
                      },
                      css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: "transparent",
                      },
                    });
                    add_forum_category_function()
                      .then(() => {
                        history.push("/dashboard/showForumCategories");
                        $.unblockUI();
                      })
                      .catch(() => {
                        utils.showAlert("خطایی به وجود آمده است", "error");
                        $.unblockUI();
                      });
                  } else {
                    utils.showAlert("اطلاعات را کامل کنید", "error");
                    $.unblockUI();
                  }
                }}
                style={{
                  marginTop: "-2rem",
                  marginRight: "25px",
                  width: "fit-content",
                }}
                type="button"
                class="btn btn-success mr-1 mb-1 "
              >
                افزودن دسته بندی جدید
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { addForumCategory };
